let baseUrl = process.env.REACT_APP_GFS_BASE_URL

export default async function HourlyData(lat, lng) {
    let url = `${baseUrl}/hrlydata?lat=${lat}&lon=${lng}`;
    let result = await fetch(url);
    return await result.json();

  }